import { render, staticRenderFns } from "./TemplateFragen.vue?vue&type=template&id=29bc8a58&"
import script from "./TemplateFragen.vue?vue&type=script&lang=js&"
export * from "./TemplateFragen.vue?vue&type=script&lang=js&"
import style0 from "./TemplateFragen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports